import React from 'react'
import { useTranslation } from 'react-i18next'

// ui-kit
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'

// mixins
import { ComponentContainer, SearchHeader, InfiniteIconWrapper } from './mixins'

export const Component = () => {
  const { t } = useTranslation()

  return (
    <ComponentContainer>
      <SearchHeader>
        <InfiniteIconWrapper>
          <Icon name="icon-light-clock" color="#FFFF" size="12" />
        </InfiniteIconWrapper>
        <Text size="xs" fontWeight="semibold" variant="extra">
          {t('Title')}
        </Text>
      </SearchHeader>
      <Text size="xs" variant="extra">
        {t('Text')}
      </Text>
    </ComponentContainer>
  )
}

export default Component
